import {Pipe, PipeTransform} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Pipe({
	standalone: true,
	name: 'photoGed'
})
export class PhotoGedPipe implements PipeTransform {

	constructor(private http: HttpClient, private sanitizer: DomSanitizer) {
	}

	transform(url: string, modeAzureblob?: boolean): Observable<SafeUrl> {
		if (/nuxeo/.test(url)) {
			return this.http
				.get(url, {responseType: 'blob'}).pipe(
					map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))));
		}
		else if (modeAzureblob) {
			const urlEncodee = encodeURIComponent(url);
			return this.http.get(`/ws/azure-blob-storage?cheminFichier=${urlEncodee}`, { responseType: 'blob' }).pipe(
				map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))));
		}
	}

}
